module.exports = __webpack_public_path__ + "img/reportChicken_1.ecff96f7.png";